import { makeStyles } from 'tss-react/mui';

import { IStyleProps } from '../interfaces';

const useStyles = makeStyles<IStyleProps | undefined>()((theme, styles) => ({
  iconButton: {
    width: styles?.width || theme.spacing(4),
    minWidth: styles?.width || theme.spacing(4),
    height: styles?.height || theme.spacing(4),
    borderRadius: styles?.borderRadius || '50%',
    backgroundColor: styles?.backgroundColor || '',
    color: styles?.color || theme.palette.primary.main,
    padding: styles?.padding || 'initial',
    '&:hover': {
      ...styles?.['&:hover'],
      backgroundColor: theme.palette.background.default,
      '& [fill]': {
        fill: styles?.color || theme.palette.primary.main,
      },
      '& [stroke]': {
        stroke: styles?.color || theme.palette.primary.main,
      },
    },

    '& svg': {
      width: `calc( ${styles?.width || theme.spacing(4)} * 0.8)`,
      height: `calc( ${styles?.height || theme.spacing(4)} * 0.8)`,
    },
  },
  iconActiveButton: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    '& [fill]': {
      fill: theme.palette.background.default,
    },
  },
  disabledButton: {
    '&:disabled': {
      color: theme.palette.grey[300],
      ...styles?.['&:disabled'],
    },
    '& [fill]': {
      fill: theme.palette.background.default,
    },
  },
}));
export default useStyles;
